// extracted by mini-css-extract-plugin
export default {"section":"Settings_section__ZLEg3","title":"Settings_title__2bEbe","colors":"Settings_colors__0hwqZ","colorItem":"Settings_colorItem__VbgBV","empty":"Settings_empty__m6aRT"};